import React from "react";
import {routes} from "../config/routes";
import Link from "../components/layout/header/menu/Link";
import {Redirect} from "react-router-dom";


class PathManager {


    constructor(history) {
        // set history if exists
        if (history) this.history = history;

        this.urlPath = "";
        this.realPaths = [];

        // get Routes
        this.routes = routes.filter(route => route.path !== '*');

        this.rootPath = process.env.PUBLIC_URL;

        // setPath as array
        this.setPath();

        document.title = `Uniprévoyance - ${this.getTitleTxt()}`
    }


    setPath = () => {
        const pathname = window.location.pathname;
        this.urlPath = pathname;
        let paths = [];

        for (let id in this.routes) {
            // Escape special regex characters in the path
            const regexPath = this.routes[id].path.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

            const regex = new RegExp(regexPath); // Create regex from the escaped path

            if (regex.test(pathname) && regexPath !== "/") { // Use regex.test instead of search
                paths = regexPath.split('/').filter(split => split !== '');
            }
        }

        if (/^[0-9]+$/.test(paths[paths.length - 1])) {
            paths.pop();
        }

        this.realPaths = paths;

        let usedPaths = [];
        let lastPath = "";

        paths.map((path, idx) => {
            let isPath = undefined;
            switch (idx) {
                case 0:
                    isPath = this.getTitleFromPath("/" + path);
                    lastPath = "/" + path;
                    if (typeof isPath !== "undefined") {
                        usedPaths.push(path);
                    }
                    break;
                case 1:
                case 2:
                case 3:
                case 4:
                    isPath = this.getTitleFromPath(lastPath + "/" + path);
                    lastPath = lastPath + "/" + path;
                    if (typeof isPath !== "undefined") {
                        usedPaths.push(path);
                    }
                    break;
                default:
            }
        });

        this.paths = usedPaths;
    }

    getTitleTxt = (id = this.getIdFromPath()) => {
        return typeof this.routes[id] !== "undefined" ? this.routes[id].title : '';
    }

    getIdFromPath = (path = this.getCurrentURLPath()) => {

        for (let id in this.routes) {
            if (this.routes[id].path === path) {
                return id
            }
        }

    }

    getCurrentURLPath = () => {
        return this.urlPath;
    }

    getCurrentPath = () => {
        return '/' + this.paths.join('/');
    }

    getCurrentPaths = () => {
        return this.paths;
    }

    getLink = (id, icon) => {

        return id ? <Link icon={icon} route={this.routes[id]}/> :
            <Link route={{path: "/ui", component: null, title: "Accueil"}}/>
    }

    getTitle = (id = this.getIdFromPath(), icon) => {

        if (typeof id === "undefined") {
            let path = this.getCurrentPath();
            for (let id in this.routes) {
                if (this.routes[id].hasOwnProperty('param') && this.routes[id].path === path) {
                    return <>{icon} {this.getTitleTxt(id)}</>
                }
            }


        } else {
            return <>{icon} {this.getTitleTxt(id)}</>

        }
    }

    getTitleFromPath = (path) => {
        const id = this.getIdFromPath(path);
        if (id) {
            return this.getTitle(id, this.routes[id].icon)
        }
    }

    getLinkFromPath = (path) => {
        const id = this.getIdFromPath(path);
        const icon = this.routes[id] !== undefined ? this.routes[id].icon : 'icon'
        return this.getLink(id, icon);
    }
    redirect = (id) => {
        return <Redirect to={this.routes[id].path}/>
    }
    goTo = (name, id, data) => {

        if (name && name === '') return;

        id = id && id !== '' ? '/' + id : '';

        data = data ? data : {};

        if (!this.history) {
            console.log(`Cannot redirect to ${name} history is not defined`)

            document.location = routes['/'].path;

            return;
        }
        const route = routes.filter(rt => rt.name === name)[0];
        if (route) {
            this.history.push({pathname: route.path + id, state: data});
            // this.history.push({pathname: route.path + id});
        } else {
            console.log(`Cannot redirect to ${name} route is not configured`)
        }
    }


    goToPath = (path, id, data) => {

        if (path && path === '') return;

        id = id && id !== '' ? '/' + id : '';

        data = data ? data : {};

        if (!this.history) {
            console.log(`Cannot redirect to ${path} history is not defined`)

            document.location = routes['/'].path;

            return;
        }

        if (path.includes('http') || path.includes('https')) {
            window.location.href = path;
        } else {
            this.history.push({pathname: path + id, state: data})
        }

    }
    goToBasedOnSection = (sectionName, id, subPage, data) => {
        this.goTo(this.getLinkNameFromType(sectionName, subPage), id, data)
    }
    goToArret = () => {
        this.goTo('sinistres-en-ligne-it')
    }
    goToInvalidite = () => {
        this.goTo('sinistres-en-ligne-ip')
    }
    goToDeces = () => {
        this.goTo('sinistres-en-ligne-dc')
    }
    getLinkNameFromType = (sectionName, subPage) => {
        subPage = subPage ? subPage : '';

        switch (sectionName) {
            case 'Invalidité':
                return 'sinistres-en-ligne-ip' + subPage;
            case 'Arrêt de travail':
                return 'sinistres-en-ligne-it' + subPage;
            case 'Suite d\'arrêt de travail':
                return 'sinistres-en-ligne-its' + subPage;
            case 'Décès':
                return 'sinistres-en-ligne-dc' + subPage;
            default:
                return '';
        }
    }
    goToForcedBasedOnSection = (sectionName) => {
        document.location = routes[this.getLinkNameFromType(sectionName)].path
    }
}

export default PathManager;
